import { LocalizedString, ResourceAssignType } from '@cue/api';

export enum ResourceReservationStatusType {
  Free = '0',
  Tentative = '1',
  Reserved = '2',
  Closed = '3',
}

export enum ResourceUnavailabilityReason {
  MinEventDuration = 'MinEventDuration',
  MaxEventDuration = 'MaxEventDuration',
  MaxDaysAdvance = 'MaxDaysAdvance',
  OutsideWorkingHours = 'OutsideWorkingHours',
  Reserved = 'Reserved',
  EventEndsInPast = 'EventEndsInPast',
}

export interface GroupedResourceListItem {
  id: string;
  resourceTypeId: number;
  resourcePropertyName: LocalizedString;
  resources: IResourceListItem[];
}

export interface IResourceListItem {
  requirementIds: string[];
  resourceId: number;
  resourceTypeId?: number;
  resourceGuid: string;
  resourceDisplayName: LocalizedString;
  resourceDisplayNameForApp: LocalizedString;
  resourceUserName: string;
  locations?: IAddinLocationDetail[];
  isAvailable: boolean;
  isAssignedTo: ResourceAssignType;
  timeLine: string;
  resourceDetailAssistUrl: string;
  availableOutsideWorkingHours: boolean;
  unavailabilityReason?: ResourceUnavailabilityReason;
  unavailabilityReasonValue?: number;
  inCurrentEvent?: boolean;
  notAllowedMultipeResourceTypeAndResourceOccupied?: boolean;
  status: any;
  assignTo: any;
}

export interface IAddinLocationDetail {
  displayName: string;
  locationUri: string;
}

export interface IAddinResourceStatus {
  status: number;
  name: string;
  color: string;
}

export interface Requirement {
  id: string;
  resourceTypeId: number;
  capacity: [number, number];
  areaIds: number[];
}

export interface IResourceFilterUpdateCrate {
  start?: Date;
  end?: Date;
  showOnlyAvailable?: boolean;
  resourceName?: string;
  iCalUid?: string | null;
  currentEventId?: string | null;
  currentEventResourceEmails?: string[];
  currentEventStart?: Date | null;
  currentEventEnd?: Date | null;
  currentEventStartLocalDateTime?: string | null;
  currentEventEndLocalDateTime?: string | null;
  currentEventStartTimeZone?: string | null;
  currentEventEndTimeZone?: string | null;
  additionalFilterList: IAdditionalFilterItem[];
}

export interface IAdditionalFilterItem {
  id: string;
  requirementId: string;
  dataTypeId: number;
  valueNumberMin: number;
  valueNumberMax: number;
  valueDecimalMin: number;
  valueDecimalMax: number;
  valueBoolean: boolean;
  valueString: string;
  capacityMin: number;
  capacityMax: number;
  valueChoiceId: string[];
}

export interface IAreaDetail {
  id: number;
  parentAreaId?: number;
  name: string;
}

export interface IPropertyFilter {
  resourceTypeId: number;
  resourceTypeName: LocalizedString;
  allowMultipleResourceReservations: boolean;
  addinPropertyDetails: IAddinPropertyDetail[];
  capacityMin: number;
  capacityMax: number;
  capacityVisible: boolean;
  resourceCount: number;
  rank: number;
}

export interface IAddinPropertyDetail {
  id: string;
  name: LocalizedString;
  dataTypeId: number;
  isFilterable: boolean;
  defaultValueNumber: number;
  defaultValueDecimal: number;
  defaultValueBoolean: boolean;
  defaultValueString: string;
  valueNumberMax: number;
  valueNumberMin: number;
  valueDecimalMax: number;
  valueDecimalMin: number;
  choiceIds: ChoiseItem[];
}

export interface ChoiseItem {
  id: string;
  imageUrl: string;
  name: LocalizedString;
}
